import { combineReducers } from "redux";
import accountReducer from "./auth";
import navigation from "./navigation";
import notifications from "./notifications";

export default combineReducers({
  accountReducer,
  navigation,
  notifications,
});
